var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfileCollections = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4255 5.12281C15.7091 4.95906 16.0585 4.95906 16.3421 5.12281L20.7082 7.64357C20.9918 7.80732 21.1666 8.10993 21.1666 8.43741V13.4789C21.1666 13.8064 20.9918 14.109 20.7082 14.2728L16.3421 16.7935C16.0585 16.9573 15.7091 16.9573 15.4255 16.7935L11.0594 14.2728C10.7758 14.109 10.6011 13.8064 10.6011 13.4789V8.43741C10.6011 8.10993 10.7758 7.80732 11.0594 7.64357L15.4255 5.12281ZM12.4344 8.96663V12.9497L15.8838 14.9413L19.3333 12.9497V8.96663L15.8838 6.97509L12.4344 8.96663Z",
    fill: "#4987FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.82442 15.2048C10.108 15.0411 10.4575 15.0411 10.7411 15.2048L15.1072 17.7256C15.3908 17.8893 15.5655 18.192 15.5655 18.5194V23.561C15.5655 23.8885 15.3908 24.1911 15.1072 24.3548L10.7411 26.8756C10.4575 27.0393 10.108 27.0393 9.82442 26.8756L5.45832 24.3548C5.17471 24.1911 5 23.8885 5 23.561V18.5194C5 18.192 5.17471 17.8893 5.45832 17.7256L9.82442 15.2048ZM6.83329 19.0487V23.0318L10.2827 25.0233L13.7322 23.0318V19.0487L10.2827 17.0571L6.83329 19.0487Z",
    fill: "#4987FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0266 15.2048C21.3102 15.0411 21.6596 15.0411 21.9432 15.2048L26.3093 17.7256C26.5929 17.8893 26.7676 18.192 26.7676 18.5194V23.561C26.7676 23.8885 26.5929 24.1911 26.3093 24.3548L21.9432 26.8756C21.6596 27.0393 21.3102 27.0393 21.0266 26.8756L16.6605 24.3548C16.3769 24.1911 16.2021 23.8885 16.2021 23.561V18.5194C16.2021 18.192 16.3769 17.8893 16.6605 17.7256L21.0266 15.2048ZM21.4849 17.0571L18.0354 19.0487V23.0318L21.4849 25.0233L24.9343 23.0318V19.0487L21.4849 17.0571Z",
    fill: "#4987FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfileCollections);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/profile-collections.60223ab993782e27fa84ffab93a57055.svg";